module.exports = __webpack_public_path__ + "img/1_018.e16f996c.jpg";